// scroll-strategy.service.ts
import { Injectable } from '@angular/core';
import {
  RepositionScrollStrategy,
  RepositionScrollStrategyConfig,
  ScrollStrategyOptions,
} from '@angular/cdk/overlay';

@Injectable({
  providedIn: 'root',
})
export class ScrollStrategyService {
  constructor(private readonly sso: ScrollStrategyOptions) {}

  createCustomScrollStrategy(): RepositionScrollStrategy {
    // Configure the reposition strategy as needed
    const repositionConfig: RepositionScrollStrategyConfig = {
      scrollThrottle: 0, // Adjust the throttle as needed
      autoClose: false, // Whether to close the overlay once the user has scrolled away completely
    };
    // Return a custom RepositionScrollStrategy
    return this.sso.reposition(repositionConfig);
  }
}
